<template>
    <div>
        <section>
            <div class="inner row5">
                <article class="infoInner">
                    <h1 class="boardTitle">회원 등록</h1>
                    <div>
                        <div class="row4">
                            <div class="topContent flex topContentR">
                                <div class="flex">
                                    <div class="tops">
                                        <div class="tabMenu secItemMG">
                                            <button class="accountTabBtn" :class="{active: currentTab===0}" v-on:click="currentTab = 0" >
                                                개인 <span></span>
                                            </button>
                                            <button class="accountTabBtn" :class="{active: currentTab===1}" v-on:click="currentTab = 1" >
                                                기업 <span></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="joinTabContent">
                                <!-- tab 1 -->
                                <div v-show="currentTab == 0">
                                    <WriteAccountUser />
                                </div>
                                <!-- tab 2 -->
                                <div v-show="currentTab == 1">
                                    <WriteAccountCorp />
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </section>
        
    </div>   
</template>

<script>
import WriteAccountUser from "@/components/join/admin/WriteAccountUser"
import WriteAccountCorp from "@/components/join/admin/WriteAccountCorp"

export default {
    name: 'AccountManagementWrite',
    components:{
        WriteAccountUser,
        WriteAccountCorp
    },
    data () {
        return {
            currentTab: 0,
            isYesCase: true,
            isNocase: false,
        }
    },
    methods:{
        
    }
}

</script>

<style scoped>
    .countSpan {
        display: inline-block;
        padding: 5px 20px;
        font-size: 24px;
        line-height: 35px;
    }
    .grayBtn {
        background: #5D5D5D;
        border: 1px solid #BDBDBD;
        color: #FFF;
    }
    .grayBorderBtn {
        border: 1px solid #5D5D5D;
        color: #5D5D5D;
    }
    .left.flex {
        align-items: flex-end;
    }
    .secItemMG button:nth-of-type(2) {
        margin: 0 0 0 10px;
    }
</style>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
        @import "~bootstrap-vue/dist/bootstrap-vue.min";
    }
</style>